import LoadFailure from '../../../components/Brand/LoadFailure';
import React, { createContext, useContext } from 'react';
import { Node } from '@tiptap/core';
import { NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import { useTranslation } from 'react-i18next';
import ReactionQuote from '../../../components/ReactionQuote';
import BrandLoader from '../../../components/Brand/BrandLoader';
import { CloseIcon } from '../../../components/Brand/Icon';
import { QUOTE_ATTRIBUTE } from '../../../components/ReactionQuote/placement';
import { stopNodeViewControlEvent } from './nodeViewControls';
import { quoteRejectionMessage } from './quoteDraft';

export const QuoteEditorContext = createContext(null);

export function QuoteView({ editor, getPos, node }) {
  const { t } = useTranslation();
  const context = useContext(QuoteEditorContext);
  if (!context) return <NodeViewWrapper contentEditable={false} />;
  const { attachment, disabled } = context;
  return <NodeViewWrapper contentEditable={false} className="editor-quote" data-no-swipe
    aria-label={t('brand:quotePreview', { defaultValue: 'Quoted opinion' })}>
    <button type="button" className="wiw-icon-button editor-quote__remove"
      aria-label={t('brand:quoteRemove', { defaultValue: 'Remove quote' })} disabled={disabled}
      onClick={() => {
        const pos = getPos();
        if (typeof pos === 'number') editor.chain().focus().deleteRange({ from: pos, to: pos + node.nodeSize }).run();
      }}><CloseIcon /></button>
    {attachment.pending && <div className="editor-quote__loading"><BrandLoader compact label={t('brand:loading')} /></div>}
    {attachment.rejection && <p role="alert">{quoteRejectionMessage(attachment.rejection, t)}</p>}
    {attachment.error && !attachment.rejection && !attachment.pending && <LoadFailure onRetry={attachment.retry} />}
    {!attachment.pending && attachment.quote && <ReactionQuote quote={attachment.quote} />}
  </NodeViewWrapper>;
}

export default Node.create({
  name: 'reactionQuote', group: 'block', atom: true, selectable: true, draggable: false,
  parseHTML() { return [{ tag: `div[${QUOTE_ATTRIBUTE}="true"]` }]; },
  renderHTML() { return ['div', { [QUOTE_ATTRIBUTE]: 'true' }]; },
  renderText() { return ''; },
  addNodeView() { return ReactNodeViewRenderer(QuoteView, { stopEvent: stopNodeViewControlEvent }); },
});
